export const parseIdFromTitle = (title: string): number | undefined => {
  const match = title.match(/\[(\d+)\]/);
  return match ? Number(match[1]) : undefined;
};
